import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Button } from '@progress/kendo-react-buttons';
import { useFormBuilder } from '../context/FormBuilderContext';
import { encodeDragId } from '../utils/dnd';
import { SectionBlock } from './SectionBlock';

export function Canvas() {
  const { document, addSection, isEditable } = useFormBuilder();
  const rootSections = document.sections.filter((s) => !s.parentId).sort((a, b) => a.order - b.order);
  const sectionIds = rootSections.map((s) => encodeDragId({ kind: 'section', sectionId: s.id }));

  return (
    <div
      style={{
        flex: 1,
        minWidth: 0,
        height: '100%',
        overflowY: 'auto',
        padding: 'var(--kendo-spacing-4)',
        background: 'var(--kendo-color-surface)',
      }}
    >
      <SortableContext items={sectionIds} strategy={verticalListSortingStrategy}>
        {rootSections.map((section) => (
          <SectionBlock key={section.id} section={section} depth={0} />
        ))}
      </SortableContext>

      {rootSections.length === 0 && (
        <div
          style={{
            textAlign: 'center',
            color: 'var(--kendo-color-subtle)',
            fontSize: 'var(--kendo-font-size-sm)',
            padding: 'var(--kendo-spacing-10) 0',
          }}
        >
          No sections yet. Add one to start building the form.
        </div>
      )}

      {isEditable && (
        <Button fillMode="outline" onClick={() => addSection()}>
          + Add section
        </Button>
      )}
    </div>
  );
}
